import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import HeaderSearcherInput from '../../../../components/inputs/HeaderSearcherInput';
import DatesSelectFilter from '../../../../components/filters/DatesSelectFilter';
import AvailableForFinancingSwitchFilter from '../../../../components/filters/AvailableForFinancingSwitchFilter';
import RefreshButton from '../../../../components/buttons/RefreshButton';
import dayjs from '../../../../config/dayjs';

const AvailableFactoringFilters = ({
  finder,
  setStates,
  setDates,
  states,
  dates,
  onRefresh,
  refreshLoading,
}) => (
  <>
    <Grid item xs={1.5} md={2} xl={1.7}>
      {onRefresh && (
        <RefreshButton
          onRefresh={onRefresh}
          loading={refreshLoading}
          id="available-factoring-filters-refresh"
        />
      )}
    </Grid>
    <Grid item xs={10.5} md={4} xl={3}>
      <Box display="flex" alignItems="center" gap={1} sx={{ width: '100%', minWidth: 0 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <HeaderSearcherInput finder={finder} />
        </Box>
      </Box>
    </Grid>
    <Grid item xs={6} md={3} xl={4}>
      <DatesSelectFilter
        setStates={setStates}
        setDates={setDates}
        states={states}
        dates={dates}
      />
    </Grid>
    <Grid item xs={6} md={3} xl={3.3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <AvailableForFinancingSwitchFilter states={states} setStates={setStates} />
    </Grid>
  </>
);

AvailableFactoringFilters.propTypes = {
  finder: PropTypes.shape({
    onFinderChange: PropTypes.func.isRequired,
    searchPlaceHolder: PropTypes.string.isRequired,
    finderValue: PropTypes.string.isRequired,
    canPasteExcel: PropTypes.bool,
    setColumnFilter: PropTypes.func,
  }),
  setStates: PropTypes.func,
  setDates: PropTypes.func,
  states: PropTypes.shape({
    dateIssued_Gte: PropTypes.string,
    dateIssued_Lte: PropTypes.string,
    availableForFinancing: PropTypes.string,
  }),
  dates: PropTypes.shape({
    dateIssued_Gte: PropTypes.instanceOf(dayjs),
    dateIssued_Lte: PropTypes.instanceOf(dayjs),
  }),
  onRefresh: PropTypes.func,
  refreshLoading: PropTypes.bool,
};

AvailableFactoringFilters.defaultProps = {
  finder: null,
  setStates: () => {},
  setDates: () => {},
  states: {},
  dates: {},
  onRefresh: undefined,
  refreshLoading: false,
};

export default AvailableFactoringFilters;
